// Generated by purs version 0.13.8
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Effect = require("../Effect/index.js");
var FRP_Event = require("../FRP.Event/index.js");
var FRP_Event_Time = require("../FRP.Event.Time/index.js");
var PointerEvent = require("../PointerEvent/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var Web_Event_EventTarget = require("../Web.Event.EventTarget/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var KeyDown = (function () {
    function KeyDown(value0) {
        this.value0 = value0;
    };
    KeyDown.create = function (value0) {
        return new KeyDown(value0);
    };
    return KeyDown;
})();
var PointerDown = (function () {
    function PointerDown(value0) {
        this.value0 = value0;
    };
    PointerDown.create = function (value0) {
        return new PointerDown(value0);
    };
    return PointerDown;
})();
var PointerUp = (function () {
    function PointerUp(value0) {
        this.value0 = value0;
    };
    PointerUp.create = function (value0) {
        return new PointerUp(value0);
    };
    return PointerUp;
})();
var PointerMove = (function () {
    function PointerMove(value0) {
        this.value0 = value0;
    };
    PointerMove.create = function (value0) {
        return new PointerMove(value0);
    };
    return PointerMove;
})();
var unpack = function (p) {
    return {
        location: {
            x: PointerEvent.offsetX(p),
            y: PointerEvent.offsetY(p)
        },
        pointerId: PointerEvent.pointerId(p)
    };
};
var repeatDelay = 200.0;
var mkEventListener = function (eventName) {
    return function (parseEvent) {
        return function (c) {
            return FRP_Event.makeEvent(function (k) {
                return function __do() {
                    var listener = Web_Event_EventTarget.eventListener(function (e) {
                        return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(k)(parseEvent(e));
                    })();
                    Web_Event_EventTarget.addEventListener(Data_Newtype.wrap(Web_Event_Event.newtypeEventType)(eventName))(listener)(false)(c)();
                    return Web_Event_EventTarget.removeEventListener(Data_Newtype.wrap(Web_Event_Event.newtypeEventType)(eventName))(listener)(false)(c);
                };
            });
        };
    };
};
var pointerDown = function (cs) {
    return FRP_Event_Time.debounce(500.0)(mkEventListener("pointerdown")(PointerEvent.fromEvent)(cs));
};
var pointerMove = mkEventListener("pointermove")(PointerEvent.fromEvent);
var pointerUp = (function () {
    var $0 = FRP_Event_Time.debounce(repeatDelay);
    var $1 = mkEventListener("pointerup")(PointerEvent.fromEvent);
    return function ($2) {
        return $0($1($2));
    };
})();
var keyDown = (function () {
    var $3 = FRP_Event_Time.debounce(repeatDelay);
    var $4 = mkEventListener("keydown")((function () {
        var $6 = Data_Functor.map(Data_Maybe.functorMaybe)(Web_UIEvent_KeyboardEvent.code);
        return function ($7) {
            return $6(Web_UIEvent_KeyboardEvent.fromEvent($7));
        };
    })());
    return function ($5) {
        return $3($4($5));
    };
})();
var getInputs = function (c) {
    return FRP_Event_Time.withTime(Control_Alt.alt(FRP_Event.altEvent)(Control_Alt.alt(FRP_Event.altEvent)(Control_Alt.alt(FRP_Event.altEvent)(Data_Functor.map(FRP_Event.functorEvent)(KeyDown.create)(keyDown(c)))(Data_Functor.map(FRP_Event.functorEvent)(function ($8) {
        return PointerDown.create(unpack($8));
    })(pointerDown(c))))(Data_Functor.map(FRP_Event.functorEvent)(function ($9) {
        return PointerUp.create(unpack($9));
    })(pointerUp(c))))(Data_Functor.map(FRP_Event.functorEvent)(function ($10) {
        return PointerMove.create(unpack($10));
    })(pointerMove(c))));
};
module.exports = {
    KeyDown: KeyDown,
    PointerDown: PointerDown,
    PointerUp: PointerUp,
    PointerMove: PointerMove,
    repeatDelay: repeatDelay,
    unpack: unpack,
    getInputs: getInputs,
    keyDown: keyDown,
    pointerDown: pointerDown,
    pointerUp: pointerUp,
    pointerMove: pointerMove,
    mkEventListener: mkEventListener
};
